<template>
  <div>
    <stars-bar
    :data="getStarsData"
    :customClass="'my-4 border-0'"
    ></stars-bar>
    <div class="d-flex flex-column flex-md-row flex-column-reverse">
      <div class="w-100 w-md-50">
        <span class="h4 d-none">
          Possible Stars, Total Earned and Missed Stars
        </span>
        <bar-chart
        :series="calculeSeries()"
        :categories="calculeCategories()"
        title=""
        yTitle="Stars"
        xTitle="Date"
        :height="300"
      />
      </div>
      <div class="d-flex flex-column justify-content-center align-items-center w-100 w-md-50 mb-3 mb-md-0">
        <span class="mb-2">
          You have Earned Stars Today
        </span>
        <circular-star-progress-bar
        :currentValue="todayStars"
        :percentageValue="totalDailyStars&&todayStars?todayStars/totalDailyStars:0"
        />
        <span class="mt-2">
          Of {{totalDailyStars}} Stars
        </span>
      </div>
    </div>
      
  </div>
</template>
<script>
import barChart from "@/components/apexCharts/MultipleChar.vue";
import circularStarProgressBar from "@/components/general/circularStarProgressBar/circularStarProgressBar"
import {  mapActions, mapGetters } from "vuex";
import StarsBar from '../general/starsBar/starsBar.vue';

export default {
  data(){
    return{
      calendarValue: "",
      availableStars: 0,
      todayStars: 0,
      totalStars: 0,
      totalDailyStars: 0,
      available_today: 0
    }
  },
  props: {
  },
  components:{
    StarsBar,
    barChart,
    circularStarProgressBar
  },
  mounted () {
    this.loadChildrenData()
  },
  methods:{
    ...mapActions("rewards", [
      "FetchChildRewards",
    ]),
    loadChildrenData(){
      this.FetchChildRewards(this.getUserId).then(()=>{
        const selectedChildReward = this.getChildSelectedRewards(this.getUserId)
        // set stars
        this.availableStars = selectedChildReward&&selectedChildReward.available_stars?selectedChildReward.available_stars:0
        this.todayStars = selectedChildReward&&selectedChildReward.today_stars?selectedChildReward.today_stars:0
        this.available_today = selectedChildReward&&selectedChildReward.available_today?selectedChildReward.available_today:0
        this.totalStars = selectedChildReward&&selectedChildReward.total_stars?selectedChildReward.total_stars:0 
      })
    },
    calculeCategories(){
      let categories = []
      if(this.getChildOwnStars.progress){
        this.getChildOwnStars.progress.map(element=>{
          categories.push(element.date)
        })
      }
      return categories
    },
    calculeSeries(){
      const barSerie = []
      const lineSerie = []
      if(this.getChildOwnStars.progress){
        this.getChildOwnStars.progress.map((element,index)=>{
          const dateObject = new Date(element.date)
          dateObject.setDate(dateObject.getDate() + 1)
          const dataString = `${dateObject.getMonth()+1}-${dateObject.getDate()}-${dateObject.getFullYear()}`

          barSerie.push({x:dataString,y:element.approved_stars})
          lineSerie.push({x:dataString, y:element.possible_stars})

          if (index==this.getChildOwnStars.progress.length-1) this.totalDailyStars = element.possible_stars
        })
      }
      return [
        {
        name:"Possible Stars",
        type:'line',
        data:lineSerie
      },
      {
        name:"Total Earned",
        type:'column',
        data:barSerie
      }
      ]
    }
  },
  computed:{
    ...mapGetters("user",["getUserId"]),
    ...mapGetters("rewards", ["getChildSelectedRewards"]),
    ...mapGetters("progress",["getChildOwnStars"]),
    getStarsData(){
      return[
        {text:`Daily Reward Stars`, stars: this.available_today, display:true},
        {text:'Big Reward Stars', stars:this.availableStars, display:true},
        {text:`Grand Total`, stars: this.totalStars, display:true}
      ]
    },
  }
}
</script>
